export default __webpack_public_path__ + "static/media/smedetoften-property-06.1679b0a7.jpg";